import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { AssetManagementPortalStore } from '../stores/assetManagementPortalStore';

export const useAssetManagementPortalStore = () =>
  useContext<AssetManagementPortalStore>(StoreContext);